<div *ngIf="(isLoading$ | async) || (parentIsLoading | async)" class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
<div class="integration" *ngIf="(isLoading$ | async) === false && (parentIsLoading | async) === false && !showNoData">
    <div class="side-strip"></div>

    <div class="integration-header">
        <div class="integration-header-page-title">
            {{ (integrationId ? "integrationPage.editTitle" : "integrationPage.addTitle") | labelsProvider }}
        </div>
        <img class="integration-header-close-button" src="assets/images/common/cancel.svg" (click)="closeWindow()" />
    </div>
    <div class="integration-header-border"></div>
    <div *ngIf="integrationId && (errorMessage | async)" class="integration-error">
        <img class="integration-error-icon" src="assets/images/common/fail-notification.svg" />
        <div class="integration-error-text">
            {{ errorMessage | async }}
        </div>
    </div>
    <div class="integration-content">
        <app-detail-keyvalue [isInAddOrEditMode]="false" [input]="integrationNameDetail"> </app-detail-keyvalue>

        <app-integration-environment [inAddMode]="!this.integrationId" [environmentFormControl]="integrationFormGroup.controls['environment']">
        </app-integration-environment>

        <app-integration-platform-selection
            [disabled]="this.integrationId !== undefined"
            [platformFormControl]="integrationFormGroup.controls['platform']">
        </app-integration-platform-selection>

        <div class="integration-content-separator" *ngIf="integrationFormGroup.controls['platform'].value"></div>

        <app-integration-auth-method
            [platformControl]="integrationFormGroup.controls['platform']"
            [authMethodControl]="integrationFormGroup.controls['authMethod']"
            [isInAddMode]="this.integrationId === undefined">
        </app-integration-auth-method>

        <app-integration-credentials
            [platformControl]="integrationFormGroup.controls['platform']"
            [authMethodControl]="integrationFormGroup.controls['authMethod']"
            [credentialsFormGroup]="credentialsFormGroup"
            [integrationCredentials]="integrationCredentials"
            [isInAddMode]="this.integrationId === undefined"
            [formSubmitAttempt]="formSubmitAttempt"
            [shouldUpdateCredentials]="shouldUpdateCredentials">
        </app-integration-credentials>

        <div class="integration-footer">
            <div class="integration-buttons-container">
                <button class="integration-button-cancel" (click)="onCancel()">
                    {{ "integrationPage.cancelButton" | labelsProvider }}
                </button>
                <button
                    class="integration-button"
                    (click)="formSubmitAttempt = true; onAddIntegration()"
                    *ngIf="this.integrationId === undefined"
                    [ngClass]="{
                        'integration-button-disabled': integrationFormGroup.invalid,
                    }"
                    [disabled]="integrationFormGroup.invalid">
                    {{ "integrationPage.createButton" | labelsProvider }}
                </button>
                <button
                    class="integration-button"
                    (click)="formSubmitAttempt = true; onUpdate()"
                    *ngIf="this.integrationId !== undefined"
                    [ngClass]="{
                        'integration-button-disabled': integrationFormGroup.invalid,
                    }"
                    [disabled]="integrationFormGroup.invalid">
                    {{ "integrationPage.saveButton" | labelsProvider }}
                </button>
            </div>
        </div>
    </div>
</div>
